import { HttpClient } from '@angular/common/http'; // HttpHeaders
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// import { MEDIA_HEADER, MEDIA_VALUE } from '@core/const';
import { EmailSubmissionPayload } from '@core/interfaces/email-submission.interface';

import { ATTACHMENTS_ENDPOINTS } from './attachment.token';

@Injectable({ providedIn: 'root' })
export class AttachmentService {
  private readonly http = inject(HttpClient);
  private readonly endpoints = inject(ATTACHMENTS_ENDPOINTS);

  public submit(
    payload: EmailSubmissionPayload,
    attachments: File[],
    opts: { connected: boolean },
  ): Observable<void> {
    // const headers = new HttpHeaders({
    //   [MEDIA_HEADER]: MEDIA_VALUE,
    //   'Content-Type': 'multipart/form-data',
    // });
    const url = opts.connected
      ? this.endpoints.connectedAttachments
      : this.endpoints.guestAttachments;
    const body = new FormData();
    body.append('email', JSON.stringify(payload));

    for (const file of attachments) body.append('attachments', file, file.name);
    return this.http.post<void>(url, body); // { headers }
  }
}
